<template>
  <component
    :is="passport ? 'router-link' : 'article'"
    :to="passport ? { name: 'passport', params: { employeeSlug: passport.slug } } : undefined"
    class="crew-card"
    :class="{ 'crew-card-linked': passport }"
  >
    <img
      v-if="photoSrc && !photoFailed"
      :src="photoSrc"
      :alt="`${displayName} headshot`"
      class="crew-photo"
      width="72"
      height="72"
      loading="lazy"
      @error="photoFailed = true"
    />
    <v-icon v-else class="crew-placeholder" aria-hidden="true">mdi-account-circle-outline</v-icon>
    <div class="crew-copy">
      <span>{{ displayName }}</span>
      <strong v-if="role">{{ role }}</strong>
      <small v-if="member.attendanceCount != null" class="crew-attendance">
        {{ member.attendanceCount }} {{ tripLabel }} {{ member.attendanceCount === 1 ? 'trip' : 'trips' }}
      </small>
      <div v-if="member.years && member.years.length" class="crew-years">{{ member.years.join(' · ') }}</div>
      <small v-if="passport" class="passport-link">View Passport <v-icon x-small aria-hidden="true">mdi-arrow-right</v-icon></small>
    </div>
  </component>
</template>

<script>
import { mediaSrc } from '../../../services/mediaAssets';
import { passportBySlug } from '../../../data/passports';
import { heroProfileByCrewSlug } from '../../../data/heroProfiles';

export default {
  name: 'CrewCard',
  props: {
    member: { type: Object, required: true },
    tripLabel: { type: String, default: '' },
  },
  data: () => ({ photoFailed: false }),
  computed: {
    passport() {
      return passportBySlug[this.member.employeeSlug || this.member.slug] || null;
    },
    displayName() {
      return this.member.displayName || this.member.name || this.passport?.displayName || '';
    },
    role() {
      return this.member.role || this.member.title || this.passport?.title || '';
    },
    photoSrc() {
      return mediaSrc(this.photo);
    },
    photo() {
      const slug = this.passport?.slug;
      return heroProfileByCrewSlug[slug]?.realImage || this.passport?.headshot
        || this.member.headshot || null;
    },
  },
  watch: {
    photoSrc() { this.photoFailed = false; },
  },
};
</script>

<style scoped>
.crew-card { align-items: center; background: #121212; border: 1px solid #2c2c2c; border-radius: 10px; color: #fff !important; display: grid; gap: 16px; grid-template-columns: 72px minmax(0, 1fr); padding: 18px; text-decoration: none; }
.crew-card-linked:hover { border-color: #f0b13c; }
.crew-card-linked:focus-visible { outline: 3px solid #f0b13c; outline-offset: 4px; }
.crew-photo { background: #202020; border-radius: 8px; height: 72px; object-fit: cover; object-position: center top; width: 72px; }
.crew-placeholder { color: #f0b13c !important; font-size: 3rem !important; width: 72px; }
.crew-copy { min-width: 0; }
.crew-copy > span { display: block; font-family: "Oswald", sans-serif; font-size: 1.3rem; font-weight: 800; }
.crew-copy strong { color: #aaa; display: block; font-size: .8rem; line-height: 1.4; margin-top: 4px; }
.crew-copy small { display: block; font-size: .75rem; margin-top: 12px; }
.passport-link, .crew-years { color: #f0b13c; }
.passport-link .v-icon { color: inherit; }
.crew-attendance { color: #ddd; }
.crew-years { font-size: .73rem; margin-top: 4px; }
</style>
